<template>
  <div ref="el">
    <div v-if="nodeData">
      <span class="d-block">
        {{ resolveNodeName(nodeData) }}
      </span>
      <span
        v-if="nodeData.data.cmd !== 'custom'"
        class="config-icon"
        @click="openConfigModal"
      >
        <feather-icon icon="SettingsIcon" size="16" class=""/>
      </span>
    </div>
    <div class="node-custom-outputs">
      <div class="custom-output" v-for="(output, index) in outputs" :key="index">
        <feather-icon
          icon="XCircleIcon"
          size="18"
          class="remove-icon"
          @click="removeOutput(output.id)"
        />
        <div class="color-picker" title="test">
          <b-form-input
            id="color"
            v-model="output.color"
            trim
            type="color"
            @input="onColorUpdate($event, index)"
          />
        </div>
        <contenteditable
          tag="p"
          :contenteditable="true"
          v-model="output.text"
          :noNL="true"
          style="display: inline-block; margin-left: 5px;"
          @input="updateOutput($event, index)"
        />
      </div>
    </div>
    <feather-icon icon="PlusCircleIcon" size="18" class="add-icon" @click="addOutput"/>
  </div>
</template>

<script>
import nodeMixin from "@/mixins/nodeMixin";
import contenteditable from "@/components/Contenteditable";
import {EventBus} from "@/libs/event-bus";
import {BFormInput} from "bootstrap-vue";

export default {
  mixins: [nodeMixin],
  components: {
    BFormInput,
    contenteditable,
  },
  data() {
    return {
      minOutputs: 2,
      outputs: [
        {
          id: "output_1",
          text: "Yes",
          color: "#ff0000",
        },
        {
          id: "output_2",
          text: "No",
          color: "#00ff00",
        },
      ],
    };
  },
  async mounted() {
    await this.$nextTick();
    this.getNodeId();
    this.getNodeData();

    if (this.nodeData.data.config) {
      if (this.nodeData.data.config.question) {
        this.question = this.nodeData.data.config.question;
      }

      if (this.nodeData.data.config.custom_outputs) {
        this.outputs = this.nodeData.data.config.custom_outputs;
      }
    } else {
      this.nodeData.data.config = {};
      this.question = this.nodeData.data.config.question = this.$t(
        "action_plan.nodes.decision.config.question"
      );
      this.updateNodeConfig();
    }
  },
  computed: {
    outputsLength() {
      return this.outputs.length;
    },
  },
  methods: {
    addOutput() {
      if (this.outputsLength === 5) return;
      this.$df.addNodeOutput(this.nodeId);
      this.outputs.push({
        id: `output_${this.outputsLength + 1}`,
        text: 'Answer',
        color: '#000000',
      });
      this.updateNodeConfig();
    },
    removeOutput(output) {
      if (this.outputsLength === 1) return;
      this.$df.removeNodeOutput(this.nodeId, output);
      this.outputs = this.outputs.filter((o) => o.id !== output);
      this.outputs.forEach((o, index) => {
        this.outputs[index].id = `output_${index + 1}`;
      });
      this.updateNodeConfig();
    },
    updateOutput(value, index) {
      this.outputs[index].text = value;
      this.updateNodeConfig();
    },
    updateNodeConfig() {
      const currentNode = this.$df.getNodeFromId(this.nodeId);
      const config = {
        ...(currentNode.data.config || {}),
        custom_outputs: this.outputs,
      };
      this.updateNodeData({ config });
    },
    openConfigModal() {
      EventBus.emit("node:open-modal", this.nodeId);
    },
    resolveNodeName() {
      return "AI Decision";
    },
    onColorUpdate($event, index) {
      this.outputs[index].color = $event;
      this.updateNodeConfig();
    },
  },
};
</script>

<style></style>
